import { atom } from 'nanostores'

/** Flips to true once EventHome's progressive disclosure has finished
 *  (~1800ms after `started`). Components like ProgressArc gate their
 *  one-shot mount animation on this so the transition isn't wasted under
 *  the still-fading opacity-0 wrapper. */
export const $pageRevealed = atom(false)

export function markPageRevealed() {
  $pageRevealed.set(true)
}
